export const AnomalyWidget = {
  Table: "table",
  HeightProfileChart: "heightProfileChart",
  Cylinder: "cylinder",
  TypesLegend: "typesLegend",
  WMSWidget: "wmsWidget",
  WMSLegend: "wmsLegend",
};
